import axios from 'axios';
import { ServerError, UserGender } from './types';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export function validateServerError(error: unknown): ServerError {
  const fallbackMessage =
    error instanceof Error ? error.message : 'An unexpected error occurred';
  if (!axios.isAxiosError(error)) {
    return { message: fallbackMessage };
  }

  const responseError: unknown = error.response?.data;
  if (!isRecord(responseError)) {
    return { message: fallbackMessage };
  }

  if (
    responseError.statusCode === 400 &&
    Array.isArray(responseError.errors)
  ) {
    const firstError = responseError.errors[0];
    if (isRecord(firstError) && isRecord(firstError.constraints)) {
      const constraintMessage = Object.values(firstError.constraints).find(
        (value): value is string => typeof value === 'string',
      );
      if (constraintMessage) {
        return {
          message: constraintMessage,
          property:
            typeof firstError.property === 'string'
              ? firstError.property
              : undefined,
        };
      }
    }
  }

  return {
    message:
      typeof responseError.message === 'string'
        ? responseError.message
        : fallbackMessage,
  };
}

export function getYearsOld(birth: number | undefined) {
  if (!birth) {
    return null;
  }

  if (birth < 100) {
    return birth;
  }

  var today = new Date();
  var birthDate = new Date(birth);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export function getGender(gender: UserGender | undefined) {
  switch (gender) {
    case UserGender.Male:
      return 'Male';
    case UserGender.Female:
      return 'Female';
    case UserGender.Other:
      return 'Not Set';
  }
}

export enum DateType {
  Joined,
  Month,
  Time,
}

export function dateFormatter(date: number | string, type: DateType) {
  const datum = new Date(date);
  let options = {};

  switch (type) {
    case DateType.Joined:
      options = { year: 'numeric', month: 'long', day: 'numeric' };
      break;
    case DateType.Month:
      options = { month: 'long', day: 'numeric', weekday: 'short' };
      break;
    case DateType.Time:
      options = { hour: '2-digit', minute: '2-digit', hour12: false };
      return datum.toLocaleTimeString([], options);
  }

  return datum.toLocaleDateString('sv-SE', options);
}
